import React from 'react';
import Logo from '@isomorphic/shared/UIView/Logo/Logo';
import Footers from '@isomorphic/shared/hotel/components/Footer/Footer';
import { Link } from 'react-router-dom';
import LogoImage from '@isomorphic/shared/hotel/assets/images/logo.png';
import FooterMenu from './FooterMenu';

const Footer = () => {
  return (
    <Footers
      logo={
        <Link to="/">
          <Logo src={LogoImage} title="hotel" />
        </Link>
      }
      menu={<FooterMenu />}
      copyright={`Copyright @ ${new Date().getFullYear()} Ziaway, Inc.`}
    />
  );
};

export default Footer;
